/* eslint-disable react/jsx-no-literals */
import React, {
    useEffect,
    useState,
    useCallback
} from 'react';
import { LoaderExt } from 'gw-components-platform-react';
import { PolicyService } from 'gw-capability-policy'
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import metadata from './PremiumAuditAccountTable.metadata.json5';
import styles from './PremiumAuditAccountTable.module.scss';
import messages from './PremiumAuditAccountTable.messages'

function PremiumAuditAccountTable(props) {
    const { authHeader, currentAccount, loading } = props;

    const [statuses, setStatuses] = useState([])
    const [noDataText, setNoDataText] = useState("Loading...")
    const terms = [messages.billed, messages.cancelled, messages.closeOut, messages.complete, messages.invoiced, messages.waived]

    const getGlossary = () => {
        const glossaryContent = [<span className={styles.glossaryTitle}>Status Definitions:</span>]

        glossaryContent.push(...terms.map((term) =>
            <span className={styles.glossaryTerm}>{term.defaultMessage}</span>
        ))

        return glossaryContent
    }

    const compareDates = (
        a,
        b
    ) => {
        const date1 = new Date(a);
        const date2 = new Date(b);

        if (date1 > date2) {
            return 1;
        }

        if (date1 < date2) {
            return -1;
        }

        return 0;
    };

    const getPremiumAuditStatus = useCallback(async (accountNumber) => {
        try {
            const auditStatuses = await PolicyService.getPremiumAuditStatusesByAccountNumber(accountNumber, authHeader);
            const minDate = new Date();
            const maxMonthsOld = 24;

            minDate.setMonth(minDate.getMonth() - maxMonthsOld);
            setStatuses(auditStatuses.filter(status => (new Date(status.statusDate)) >= minDate));
            setNoDataText('No data found.');
        } catch (error) {
            setNoDataText('No data found, an error occurred.');
        }
    }, [authHeader]);

    useEffect(() => {
        if (currentAccount && currentAccount?.trim() !== '') {
            getPremiumAuditStatus(currentAccount)
        }
    }, [currentAccount, getPremiumAuditStatus]);

    const getCaseID = (status) => <span>{status.caseID}</span>

    const getPolicyNumber = (status) => <span>{status.policyNumber}</span>

    const getAccountNumber = (status) => <span>{status.accountNumber}</span>

    const getStatus = (status) => <span>{status.status}</span>

    const getDetailedStatus = (status) => <span>{status.detailedStatus}</span>

    const formatDate = (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${month}/${day}/${year}`;
    };

    const getEffectiveDate = (status) => <span>{formatDate(new Date(status.effectiveDate))}</span>

    const getExpirationDate = (status) => <span>{formatDate(new Date(status.expirationDate))}</span>

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            phoneWide: {
                labelPosition: 'top',
            },
        },
        tableGridDiv: {
            visible: !loading,
        },
        tableGrid: {
            data: statuses,
            noDataText
        },
        GlossaryContainer: {
            visible: !loading,
            content: getGlossary()
        },
        tableTitle: {
            visible: !loading
        },
        supportLink: {
            visible: !loading
        },
        supportText: {
            visible: !loading
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
        },
        resolveCallbackMap: {
            getCaseID,
            getPolicyNumber,
            getStatus,
            getDetailedStatus,
            getEffectiveDate,
            getExpirationDate,
            compareDates,
            getAccountNumber
        },
    };

    return (
        <React.Fragment>
            { loading && <LoaderExt loaded={!loading} /> }
            <MetadataContent uiProps={metadata.pageContent} overrideProps={overrideProps} {...resolvers} />
        </React.Fragment>
    );
}

export default withAuthenticationContext(PremiumAuditAccountTable);
